import { createContext, useState } from 'react';
import api from 'services/api';

export const SituacaoTributariaContext = createContext();

export const SituacaoTributariaProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [situacaoTributaria, setSituacaoTributaria] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getSituacaoTributaria = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: situacaoTributaria?.filter,
        page: situacaoTributaria?.page,
        size: situacaoTributaria?.size,
        order: situacaoTributaria?.order,
        ...payload,
      });
      setSituacaoTributaria((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <SituacaoTributariaContext.Provider
      value={{
        getLoading,
        situacaoTributaria,
        getSituacaoTributaria,
      }}
    >
      {children}
    </SituacaoTributariaContext.Provider>
  );
};
